/* eslint-disable jsx-a11y/label-has-associated-control */
import { Tooltip } from '@mui/material'
import { Info } from '@mui/icons-material'
import React from 'react'

import Container, { InfoWrapper, SwitchWrapper } from './styles'

function SwitchContainer(props) {
  const { children, leftLabelText, rightLabelText, title, tooltipText } = props
  return (
    <Container>
      <InfoWrapper>
        <span className='title'>{title}</span>
        {tooltipText && <Tooltip
          title={
            <strong>{tooltipText}</strong>
          }
        >
          <Info style={{ color: '#AAAAAA' }} fontSize='small' />
        </Tooltip>}
      </InfoWrapper>
      <SwitchWrapper>
        <label htmlFor='show-switch' className='switch-label'>{leftLabelText}</label>
        {children}
        <label htmlFor='show-switch' className='switch-label'>{rightLabelText}</label>  
      </SwitchWrapper>
    </Container>
  )
}

export default SwitchContainer
